import React, { useRef } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation, Pagination, Keyboard } from "swiper"
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai"

export default ({ data = [], currentImage }) => {
  const prevRef = useRef(null)
  const nextRef = useRef(null)
  const sliderRef = useRef()

  return (
    <Swiper
      ref={sliderRef}
      slidesPerView={1}
      spaceBetween={30}
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      draggable="false"
      modules={[Keyboard, Pagination, Navigation]}
      className="mySwiper max-w-full"
      navigation={{
        prevEl: prevRef.current,
        nextEl: nextRef.current,
      }}
      coverflowEffect={{
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
      }}
      onSwiper={(swiper) => {
        swiper.slideTo(currentImage)
        setTimeout(() => {
          swiper.params.navigation.prevEl = prevRef.current
          swiper.params.navigation.nextEl = nextRef.current
          swiper.navigation.destroy()
          swiper.navigation.init()
          swiper.navigation.update()
        })
      }}
    >
      {data.map((item, idx) => (
        <SwiperSlide key={`${idx + 1}`} className="h-full">
          <img
            src={item?.image}
            alt={item?.thumb}
            loading="lazy"
            className="w-full object-contain bg-cover h-full max-h-[70vh]"
          />
        </SwiperSlide>
      ))}
      <button
        ref={prevRef}
        className="hidden md:block absolute top-1/2 left-2 text-4xl z-50 rounded-full border"
      >
        <AiOutlineLeft color="white" />
      </button>
      <button
        ref={nextRef}
        className="hidden md:block absolute top-1/2 right-2 text-4xl z-50 rounded-full border"
      >
        <AiOutlineRight color="white" />
      </button>
    </Swiper>
  )
}
